import { JSX, ReactNode, 
  // lazy 
} from "react";

import { ROUTE } from "../types/router";
import CreateEventPage from "@/pages/createEvent/CreateEventPage";
import EditEventPage from "@/pages/editEvent/EditEventPage";
import DiscountManagementPage from "@/pages/discountManagement/DiscountManagementPage";
import CreateDiscountPage from "@/pages/createDiscount/CreateDiscountPage";
import EditDiscountPage from "@/pages/editDiscount/EditDiscountPage";
import ReferralPointsPage from "@/pages/referralPoints/ReferralPointsPage";
import BookingPointsPage from "@/pages/bookingPoints/BookingPointsPage";
import RefundPage from "@/pages/refund/RefundPage";
import FlightDiscountManagementPage from "@/pages/flightDiscountManagement/FlightDiscountManagementPage";
import CreateFlightDiscountPage from "@/pages/createFlightDiscount/CreateDiscountPage";
import EditFlightDiscountPage from "@/pages/editFlightDiscount/EditFlightDiscountPage";
import RefundFlightPage from "@/pages/refundFlight/RefundFlightPage";
import { Navigate } from "react-router-dom";

// const ListEventsPage = lazy(() => import("@/pages/listEvents/ListEventsPage"));
interface Route {
  path: string;
  element: ReactNode;
  title?: string;
  icon?: JSX.Element;
}

export const routes: Route[] = [
  // Hide event management page
  { path: ROUTE.Home, element: <Navigate to={ROUTE.DiscountManagement} />, title: "List of Events" },
  {
    path: ROUTE.CreateEvent,
    element: <CreateEventPage />,
    title: "Create Event",
  },
  {
    path: `${ROUTE.EditEvent}/:id`,
    element: <EditEventPage />,
    title: "Update Event",
  },
  {
    path: `${ROUTE.DiscountManagement}`,
    element: <DiscountManagementPage />,
    title: "Discount Management",
  },
  {
    path: `${ROUTE.CreateDiscount}`,
    element: <CreateDiscountPage />,
    title: "Create Discount",
  },
  {
    path: `${ROUTE.EditDiscount}/:id`,
    element: <EditDiscountPage />,
    title: "Edit Discount",
  },
  {
    path: `${ROUTE.BookingPoints}`,
    element: <BookingPointsPage />,
    title: "Booking Points",
  },
  {
    path: `${ROUTE.ReferralPoints}`,
    element: <ReferralPointsPage />,
    title: "Referral Points",
  },
  {
    path: `${ROUTE.Refund}`,
    element: <RefundPage />,
    title: "Refund",
  },
  {
    path: `${ROUTE.FlightDiscountManagement}`,
    element: <FlightDiscountManagementPage />,
    title: "Flight Discount Management",
  },
  {
    path: `${ROUTE.CreateFlightDiscount}`,
    element: <CreateFlightDiscountPage />,
    title: "Create Flight Discount",
  },
  {
    path: `${ROUTE.EditFlightDiscount}/:id`,
    element: <EditFlightDiscountPage />,
    title: "Edit Flight Discount",
  },
  {
    path: `${ROUTE.RefundFlight}`,
    element: <RefundFlightPage />,
    title: "Refund Flight",
  },
];
